import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { useInView } from '../hooks/useInView';

const clients = [
  { name: 'Nordex', logo: 'https://yirawindservices.mx/wp-content/uploads/2026/03/NORDEX-yirawindservices.webp' },
  { name: 'Vestas', logo: 'https://yirawindservices.mx/wp-content/uploads/2026/03/VESTAS-yirawindservices.webp' },
  { name: 'Acciona', logo: 'https://yirawindservices.mx/wp-content/uploads/2026/03/ACCIONA-yirawindservices.webp' },
  { name: 'TPI Composites', logo: 'https://companieslogo.com/img/orig/TPIC.D-84d96bc7.svg?t=1720244494' },
];
const certifications = ['GWO', 'IRATA', 'ISO'];

export default function ClientBar() {
  const { t } = useLanguage();
  const [ref, isInView] = useInView();

  return (
    <section
      ref={ref}
      data-testid="client-bar"
      className="bg-[#16213E] py-10 border-y border-white/5"
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-6">
          {/* Trusted by */}
          <div className="flex flex-wrap items-center gap-6">
            <span className="text-[#B0B0B0] text-sm font-medium tracking-wide uppercase">
              {t.clients.trustedBy}
            </span>
            {clients.map((client, i) => (
              <span
                key={client.name}
                data-testid={`client-${client.name.toLowerCase().replace(/\s/g, '-')}`}
                className={`transition-all duration-500 ${
                  isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'
                }`}
                style={{ transitionDelay: `${i * 100}ms` }}
              >
                {client.logo ? (
                  <img
                    src={client.logo}
                    alt={client.name}
                    className="h-10 w-auto object-contain brightness-0 invert opacity-80 hover:opacity-100 transition-opacity duration-300"
                  />
                ) : (
                  <span className="text-white/70 text-sm font-semibold tracking-wide hover:text-white transition-colors duration-300">
                    {client.name}
                  </span>
                )}
              </span>
            ))}
          </div>

          {/* Certified */}
          <div className="flex items-center gap-3">
            <span className="text-[#B0B0B0] text-sm font-medium tracking-wide uppercase">
              {t.clients.certified}
            </span>
            {certifications.map((cert, i) => (
              <span
                key={cert}
                data-testid={`cert-${cert.toLowerCase()}`}
                className={`text-white/80 text-sm font-semibold tracking-wide transition-all duration-500 ${
                  isInView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-3'
                }`}
                style={{ transitionDelay: `${(clients.length + i) * 100}ms` }}
              >
                {cert}
                {i < certifications.length - 1 && (
                  <span className="text-[#E71C25] ml-3">|</span>
                )}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
